import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Badge, Collapse, Icon, List } from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { handleTimePsikotest } from "../../pages/User/Dashboard/Assesment/handleTimePsikotest";
import { getDetailCandidate } from "../../shared/atom/detailCandidate";

export function MenuAdmin(props) {
  const location = useLocation();
  const { openMenuMaster, setOpenMenuMaster } = props;
  const { pathname } = location;
  const splitLocation = pathname.split("/Admin");

  const handleClick = () => {
    setOpenMenuMaster(!openMenuMaster);
  };

  return (
    <React.Fragment>
      <Link to="/Admin">
        <ListItemButton selected={splitLocation[1] === "" ? true : false}>
          <ListItemIcon>
            <Icon className="material-icons-outlined">dashboard</Icon>
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItemButton>
      </Link>

      <ListItemButton
        onClick={handleClick}
        selected={
          splitLocation[1] === "/division" ||
            splitLocation[1] === "/clinic" ||
            splitLocation[1] === "/officelocation" ||
            splitLocation[1] === "/information"
            ? true
            : false
        }
      >
        <ListItemIcon>
          <Icon className="material-icons-outlined">description</Icon>
        </ListItemIcon>
        <ListItemText primary="Data Management" />
        {openMenuMaster ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={openMenuMaster} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Link to="/Admin/division">
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <Icon>list_alt</Icon>
              </ListItemIcon>
              <ListItemText primary="Division" />
            </ListItemButton>
          </Link>
          <Link to="/Admin/clinic">
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <Icon className="material-icons-outlined">local_hospital</Icon>
              </ListItemIcon>
              <ListItemText primary="Clinic" />
            </ListItemButton>
          </Link>
          <Link to="/Admin/officelocation">
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <Icon className="material-icons-outlined">apartment</Icon>
              </ListItemIcon>
              <ListItemText primary="Office Location" />
            </ListItemButton>
          </Link>
          <Link to="/Admin/information">
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <Icon className="material-icons-outlined">info</Icon>
              </ListItemIcon>
              <ListItemText primary="Information" />
            </ListItemButton>
          </Link>
          <Link to="/Admin/testimonial">
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <Icon className="material-icons-outlined">handshake</Icon>
              </ListItemIcon>
              <ListItemText primary="Testimonial"/>
            </ListItemButton>
          </Link>
          <Link to="/Admin/demography">
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <Icon className="material-icons-outlined">groups</Icon>
              </ListItemIcon>
              <ListItemText primary="Demography"/>
            </ListItemButton>
          </Link>
        </List>
      </Collapse>
      <ListItemButton>
        <ListItemIcon>
          <Icon className="material-icons-outlined">summarize</Icon>
        </ListItemIcon>
        <ListItemText primary="HR Report" />
      </ListItemButton>
    </React.Fragment>
  );
}

export function MenuCandidate() {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/career");
  const candidate = useRecoilValue(getDetailCandidate);
  return (
    <React.Fragment>
      <Link to="/career/home">
        <ListItemButton selected={splitLocation[1] === "/home" ? true : false}>
          <ListItemIcon>
            <Icon className="material-icons-outlined">dashboard</Icon>
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItemButton>
      </Link>
      <Link to="/career/joblist">
        <ListItemButton
          selected={splitLocation[1] === "/joblist" ? true : false}
        >
          <ListItemIcon>
            <Icon>list_alt</Icon>
          </ListItemIcon>
          <ListItemText primary="Job List" />
        </ListItemButton>
      </Link>
      <Link to="/career/assessment">
        <ListItemButton
          selected={splitLocation[1] === "/assessment" ? true : false}
        >
          <ListItemIcon>
            <Badge
              variant="dot"
              color="primary"
              invisible={!handleTimePsikotest(candidate.psikotest_date)}
            >
              <Icon>feed</Icon>
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Assessment" />
        </ListItemButton>
      </Link>
    </React.Fragment>
  );
}
